import { render, staticRenderFns } from "./TranscriptPart.vue?vue&type=template&id=76044380&scoped=true&"
import script from "./TranscriptPart.vue?vue&type=script&lang=ts&"
export * from "./TranscriptPart.vue?vue&type=script&lang=ts&"
import style0 from "./TranscriptPart.vue?vue&type=style&index=0&id=76044380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76044380",
  null
  
)

export default component.exports